import React, { useState } from "react";
import { Facebook, Twitter, Link as LinkIcon, Share2, Phone } from "lucide-react";


const ShareButtons = ({ blogUrl, blogTitle }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(blogUrl);
  const encodedTitle = encodeURIComponent(blogTitle);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(blogUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-col gap-4 bg-white border border-gray-200 rounded-lg p-4 my-3">
      {/* Title */}
      <div className="flex items-center text-black font-semibold text-lg">
        <Share2 className="w-5 h-5 text-[#4e59c2] mr-2" />
        Share this blog
      </div>

      {/* Buttons */}
      <div className="grid grid-cols-2 sm:flex sm:flex-row gap-3">
        {/* WhatsApp */}
        <a
          href={`https://api.whatsapp.com/send?text=${encodedTitle} - ${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-[#e2e7f7] text-black text-sm font-medium hover:bg-[#ccd4f1] transition"
        >
          <Phone className="w-4 h-4 text-green-600" /> WhatsApp
        </a>

        {/* Facebook */}
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-[#4e59c2] text-white text-sm font-medium hover:bg-[#4449b1] transition"
        >
          <Facebook className="w-4 h-4" /> Facebook
        </a>

        {/* Twitter / X */}
        <a
          href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-black text-white text-sm font-medium hover:bg-gray-900 transition"
        >
          <Twitter className="w-4 h-4" /> Twitter
        </a>

        {/* Copy Link */}
        <button
          onClick={handleCopyLink}
          className="flex justify-center items-center gap-2 px-4 py-2 rounded-md bg-gray-100 text-black text-sm font-medium hover:bg-gray-200 transition"
        >
          <LinkIcon className="w-4 h-4" />
          {copied ? "Link Copied!" : "Copy Link"}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
